import TitleWithListOfImages from './title-with-list-of-images';
export default TitleWithListOfImages;
